// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-general .tag-active {
  background-color: #588157;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
  text-transform: capitalize;
}
.tag-general .tag-ongoing {
  background-color: #b5e48c;
  color: #000000;
  font-weight: normal;
  min-width: 5rem;
  text-transform: capitalize;
}

.tag-general .tag-complete {
  background-color: #25a18e;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
  text-transform: capitalize;
}
.tag-general .tag-inactive {
  background-color: #778da9;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
  text-transform: capitalize;
}
.tag-general .tag-terminated {
  background-color: #323031;
  color: #ffffff;
  font-weight: normal;
  min-width: 5rem;
  text-transform: capitalize;
}

.tag-general .tag-Dotted {
  background-color: #e5e5f7;
  opacity: 0.8;
  background: repeating-linear-gradient(
    -45deg,
    #444cf7,
    #444cf7 1px,
    #a9cce3 1px,
    #a9cce3 5px
  );
  min-width: 5rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/common/TagGeneral/TagGeneral.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ;;;;;;GAMC;EACD,eAAe;AACjB","sourcesContent":[".tag-general .tag-active {\n  background-color: #588157;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n  text-transform: capitalize;\n}\n.tag-general .tag-ongoing {\n  background-color: #b5e48c;\n  color: #000000;\n  font-weight: normal;\n  min-width: 5rem;\n  text-transform: capitalize;\n}\n\n.tag-general .tag-complete {\n  background-color: #25a18e;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n  text-transform: capitalize;\n}\n.tag-general .tag-inactive {\n  background-color: #778da9;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n  text-transform: capitalize;\n}\n.tag-general .tag-terminated {\n  background-color: #323031;\n  color: #ffffff;\n  font-weight: normal;\n  min-width: 5rem;\n  text-transform: capitalize;\n}\n\n.tag-general .tag-Dotted {\n  background-color: #e5e5f7;\n  opacity: 0.8;\n  background: repeating-linear-gradient(\n    -45deg,\n    #444cf7,\n    #444cf7 1px,\n    #a9cce3 1px,\n    #a9cce3 5px\n  );\n  min-width: 5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
